import { getCrmColors } from "../../theme/crmColors";
import React, { useState, useEffect, useContext, useRef, useCallback } from "react";
import { useParams, useHistory } from "react-router-dom";

import clsx from "clsx";

import { IconButton, makeStyles, Paper, Tooltip } from "@material-ui/core";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import ContactDrawer from "../ContactDrawer";
import MessageInput from "../MessageInput";
import TicketHeader from "../TicketHeader";
import TicketInfo from "../TicketInfo";
import TicketActionButtons from "../TicketActionButtonsCustom";
import MessagesList from "../MessagesList";
import api from "../../services/api";
import { fetchContactTagsContext } from "../../services/contactTags";
import { ReplyMessageProvider } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { ForwardMessageProvider } from "../../context/ForwarMessage/ForwardMessageContext";

import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TagsContainer } from "../TagsContainer";
import { isNil } from 'lodash';
import { EditMessageProvider } from "../../context/EditingMessage/EditingMessageContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import { applyContactPhotoPatch } from "../../services/contactPhoto";
import useContactPhotoUpdates, { useIndividualContactPhoto } from "../../hooks/useContactPhotoUpdates";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100%",
    position: "relative",
    overflow: "hidden",
    background: theme.mode === "light" ? "#ffffff" : (theme.ticketDark ? getCrmColors(theme, "dark").background : "#2b2b2b"),
  },

  mainWrapper: {
    flex: 1,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    borderRadius: 0,
    border: 0,
    background: theme.mode === "light" ? "#ffffff" : (theme.ticketDark ? getCrmColors(theme, "dark").background : "#2b2b2b"),
    marginRight: 0,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },

  mainWrapperShift: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  tagsWrapper: {
    border: 0,
    borderRadius: 0,
    background: theme.mode === "light" ? "#f8fbff" : (theme.ticketDark ? getCrmColors(theme, "dark").inset : "#343434"),
    borderBottom: theme.mode === "light" ? "1px solid #e6edf6" : (theme.ticketDark ? `1px solid ${getCrmColors(theme, "dark").border}` : "1px solid rgba(255,255,255,0.08)"),
    padding: theme.spacing(0.75, 1),
  },
  tagToggleButton: {
    alignSelf: "center",
    marginRight: theme.spacing(0.5),
    color: theme.mode === "light" ? theme.palette.primary.main : (theme.ticketDark ? "#FFFFFF" : "#dbeafe"),
    backgroundColor: "transparent",
    borderRadius: 8,
    "&:hover": {
      backgroundColor: theme.mode === "light" ? "#edf6ff" : (theme.ticketDark ? getCrmColors(theme, "dark").background : "#424242"),
    },
  },
}));

const Ticket = () => {
  const { ticketId } = useParams();
  const history = useHistory();
  const classes = useStyles();

  const { user, socket } = useContext(AuthContext);
  const { setTabOpen } = useContext(TicketsContext);


  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [contact, setContact] = useState({});
  const [ticket, setTicket] = useState({});
  const [dragDropFiles, setDragDropFiles] = useState([]);
  const [tagsOpen, setTagsOpen] = useState(false);
  const { companyId } = user;
  const mergePhotoSnapshot = useContactPhotoUpdates({ companyId, socket, onPatch: patch => {
    setContact(current => applyContactPhotoPatch(current, patch));
    setTicket(current => applyContactPhotoPatch(current, patch));
  } });
  const onPhotoError = useIndividualContactPhoto({ companyId, contact, enabled: !loading && String(ticket.uuid) === String(ticketId) });
  const tagsRecipient = useRef();
  tagsRecipient.current = { id: ticket.id, contactId: contact.id, uuid: ticket.uuid, ready: !loading && String(ticket.uuid) === String(ticketId) };
  const applyContactTags = useCallback(data => {
    const current = tagsRecipient.current;
    if (!current?.ready || Number(data?.ticketId) !== Number(current.id) || Number(data?.contactId) !== Number(current.contactId) || !Array.isArray(data.tags) || !Array.isArray(data.selectedTagIds)) return;
    const selected = new Set(data.selectedTagIds.map(Number));
    setContact(previous => Number(previous.id) === Number(current.contactId) ? { ...previous, tags: data.tags.filter(tag => selected.has(Number(tag.id))) } : previous);
  }, []);

  useEffect(() => {
    if (!tagsRecipient.current.ready || !socket || !companyId || !["open", "pending", "group"].includes(ticket.status)) return undefined;
    const recipient = { ...tagsRecipient.current };
    let live = true, timer, sequence = 0;
    const onInvalidate = event => {
      if (event?.action !== "invalidate" || Number(event.contactId) !== Number(recipient.contactId)) return;
      clearTimeout(timer); const read = ++sequence;
      timer = setTimeout(async () => {
        try {
          const { data } = await fetchContactTagsContext(recipient.id);
          if (live && read === sequence && tagsRecipient.current.ready && String(tagsRecipient.current.uuid) === String(recipient.uuid)) applyContactTags(data);
        } catch { /* A refresh failure must not clear the last known customer tags. */ }
      }, 400);
    };
    const channel = `company-${companyId}-contact-tags`;
    socket.on(channel, onInvalidate);
    return () => { live = false; sequence += 1; clearTimeout(timer); socket.off(channel, onInvalidate); };
  }, [ticketId, ticket.id, ticket.uuid, ticket.status, contact.id, loading, companyId, socket, applyContactTags]);

  useEffect(() => {
    console.log("======== Ticket ===========")
    console.log(ticket)
    console.log("===========================")
}, [ticket])

  useEffect(() => {
    let live = true;
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchTicket = async () => {
        try {

          if (!isNil(ticketId) && ticketId !== "undefined") {

            const { data } = await api.get("/tickets/u/" + ticketId);
            if (!live) return;

            setContact(current => mergePhotoSnapshot(data.contact, current));
            // setWhatsapp(data.whatsapp);
            // setQueueId(data.queueId);
            setTicket(current => mergePhotoSnapshot(data, current));
            if (["pending", "open", "group"].includes(data.status)) {
              setTabOpen(data.status);
            }
            setLoading(false);
          }
        } catch (err) {
          if (!live) return;
          setLoading(false);
          history.push("/tickets");   // correção para evitar tela branca uuid não encontrado Feito por Altemir 16/08/2023
          toastError(err);
        }
      };
      fetchTicket();
    }, 500);

    return () => {
      live = false;
      clearTimeout(delayDebounceFn);
    };
  }, [ticketId, user, history, mergePhotoSnapshot]);

  useEffect(() => {
    if (!ticket && !ticket.id && ticket.uuid !== ticketId && ticketId === "undefined") {
      return;
    }

    if (user.companyId) {
      //    const socket = socketManager.GetSocket();

      const onConnectTicket = () => {
        socket.emit("joinChatBox", `${ticket.id}`);
      }

      const onCompanyTicket = (data) => {
        if (data.action === "update" && data.ticket.id === ticket?.id) {
          setTicket(current => mergePhotoSnapshot(data.ticket, current));
        }

        if (data.action === "delete" && data.ticketId === ticket?.id) {
          history.push("/tickets");
        }
      };

      const onCompanyContactTicket = (data) => {
        if (data.action === "update") {
          // if (isMounted) {
          setContact((prevState) => {
            if (prevState.id === data.contact?.id) {
              return { ...prevState, ...mergePhotoSnapshot(data.contact, prevState) };
            }
            return prevState;
          });
          // }
        }
      };

      socket.on("connect", onConnectTicket)
      socket.on(`company-${companyId}-ticket`, onCompanyTicket);
      socket.on(`company-${companyId}-contact`, onCompanyContactTicket);

      return () => {

        socket.emit("joinChatBoxLeave", `${ticket.id}`);
        socket.off("connect", onConnectTicket);
        socket.off(`company-${companyId}-ticket`, onCompanyTicket);
        socket.off(`company-${companyId}-contact`, onCompanyContactTicket);
      };
    }
  }, [ticketId, ticket, history, mergePhotoSnapshot]);

  const handleDrawerOpen = useCallback(() => {
    setDrawerOpen(true);
  }, []);

  const handleDrawerClose = useCallback(() => {
    setDrawerOpen(false);
  }, []);

  const renderMessagesList = () => {
    return (
      <>
        <MessagesList
          isGroup={ticket.isGroup}
          onDrop={setDragDropFiles}
          whatsappId={ticket.whatsappId}
          queueId={ticket.queueId}
          channel={ticket.channel}
        >
        </MessagesList>
        <MessageInput
          ticketId={ticket.id}
          ticketUuid={ticket.uuid}
          requestedTicketUuid={ticketId}
          ticketLoading={loading || String(ticket.uuid) !== String(ticketId)}
          ticketStatus={ticket.status}
          ticketChannel={ticket.channel}
          droppedFiles={dragDropFiles}
          contactId={contact.id}
          ticketContact={contact}
          ticketWhatsappId={ticket.whatsappId}
          ticketConnection={ticket.whatsapp || { id: ticket.whatsappId, name: "Conexão do atendimento" }}
          onTagsSaved={applyContactTags}
        />
      </>
    );
  };


  return (
    <div className={classes.root} id="drawer-container">
      <Paper
        variant="outlined"
        elevation={0}
        className={clsx(classes.mainWrapper, {
          [classes.mainWrapperShift]: drawerOpen,
        })}
      >
        {/* <div id="TicketHeader"> */}
        <TicketHeader loading={loading}>
          {ticket.contact !== undefined && (
            <div id="TicketHeader">
              <TicketInfo
                onPhotoError={onPhotoError}
                contact={contact}
                ticket={ticket}
                onClick={handleDrawerOpen}
              />
            </div>
          )}
          <Tooltip title={tagsOpen ? "Ocultar tags" : "Mostrar tags"}>
            <IconButton
              className={classes.tagToggleButton}
              onClick={() => setTagsOpen((prev) => !prev)}
              size="small"
            >
              <LocalOfferIcon fontSize="small" />
              {tagsOpen ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
            </IconButton>
          </Tooltip>
          <TicketActionButtons
            ticket={ticket}
          />
        </TicketHeader>
        {/* </div> */}
        {tagsOpen && (
          <Paper elevation={0} square className={classes.tagsWrapper}>
            <TagsContainer contact={contact} ticketId={ticket.id} blocked={loading || String(ticket.uuid) !== String(ticketId)} />
          </Paper>
        )}
        <ReplyMessageProvider>
          <ForwardMessageProvider>
            <EditMessageProvider>
              {renderMessagesList()}
            </EditMessageProvider>
          </ForwardMessageProvider>
        </ReplyMessageProvider>
      </Paper>

      <ContactDrawer
        open={drawerOpen}
        handleDrawerClose={handleDrawerClose}
        contact={contact}
        loading={loading}
        ticket={ticket}
      />

    </div>
  );
};

export default Ticket;
